/**
 * Mixin (factory) that rerenders a React component and sets its state
 * appropriately whenever a Backbone model changes.
 *
 * Example:
 *     var MissionDashboard = React.createClass({
 *         mixins: [BackboneStateMixin({
 *             getModel: (props) => props.mission,
 *             getState: (model, props) => ({
 *                 tasksLocked: model.tasksLocked(),
 *                 upcomingBadges: model.getUpcomingBadges()
 *             })
 *         })],
 *         render: function() {
 *             if (this.state.tasksLocked) {
 *                 return null;
 *             }
 *             return <UpcomingBadges badges={this.state.upcomingBadges} />;
 *         },
 *         shouldComponentUpdate: function(nextProps, nextState) {
 *             // Rerender dashboard only when tasksLocked changes
 *             return nextState.tasksLocked !== this.state.tasksLocked;
 *         }
 *     });
 */
const BackboneStateMixin = function (config) {
    // We keep per-component mixin state in component[storageKey] to avoid
    // conflicting with other instances of this mixin
    const storageKey = `backboneStateMixin${Date.now()}`;

    function updateListener(component) {
        const storage = component[storageKey];
        const model = config.getModel(component.props);

        if (storage.model === model) {
            return;
        }

        clearListener(component);
        model.on("change", handleChange);
        storage.model = model;
        storage.listener = handleChange;

        function handleChange() {
            // TODO: Coalesce multiple changes into one
            component.setState(config.getState(model, component.props));
        }
    }

    function clearListener(component) {
        const storage = component[storageKey];
        const oldModel = storage.model;
        if (oldModel) {
            oldModel.off("change", storage.listener);
        }
    }

    return {
        getInitialState: function () {
            // @ts-expect-error Property 'props' does not exist on type '{ getInitialState: () => any; componentDidMount: () => void; UNSAFE_componentWillReceiveProps: (nextProps: any) => void; componentWillUnmount: () => void; }'
            const model = config.getModel(this.props);
            // @ts-expect-error Property 'props' does not exist on type '{ getInitialState: () => any; componentDidMount: () => void; UNSAFE_componentWillReceiveProps: (nextProps: any) => void; componentWillUnmount: () => void; }'
            return config.getState(model, this.props);
        },

        componentDidMount: function () {
            this[storageKey] = {};
            updateListener(this);
        },

        UNSAFE_componentWillReceiveProps: function (nextProps) {
            updateListener(this);
            const model = config.getModel(nextProps);
            // @ts-expect-error Property 'setState' does not exist on type '{ getInitialState: () => any; componentDidMount: () => void; UNSAFE_componentWillReceiveProps: (nextProps: any) => void; componentWillUnmount: () => void; }'
            this.setState(config.getState(model, nextProps));
        },

        componentWillUnmount: function () {
            clearListener(this);
        },
    };
};

export default BackboneStateMixin;
